import { db } from "../../services/firebase/Config";
import moment from 'moment-timezone';
import {
  NEW_PACIENTE,
  SET_PACIENTE,
  ADD_PATOLOGIA,
  REMOVE_PATOLOGIA,
  UPDATE_PATOLOGIA,
} from "./pacienteTypes";

import { addPacienteInArray } from "../pacientes/pacientesActions";
import { httpRequest, httpSuccess, httpFailure, setPacienteSesion } from "../sesion/sesionActions";
import { crearCuenta, getCuenta } from "../cuenta/cuentaActions";
import { fetchPrestations } from "../prestations/prestationsActions";
import { getOdontograma } from "../odontograma/odontogramaActions";
import { fetchDiagnosticos } from "../diagnosticos/diagnosticosActions";

export const addPatologia = (patologia) => {
  return {
    type: ADD_PATOLOGIA,
    payload: patologia,
  };
};

export const removePatologia = (patologia) => {
  return {
    type: REMOVE_PATOLOGIA,
    payload: patologia,
  };
};

export const updatePatologia = (patologia) => {
  return {
    type: UPDATE_PATOLOGIA,
    payload: patologia,
  };
};

export const setPaciente = (payload) => {
  return {
    type: SET_PACIENTE,
    payload,
  };
};

export const newPaciente = () => {
  return {
    type: NEW_PACIENTE,
  };
};
const fechaACadena = (fecha) => {
  let f;
  if (fecha === null || fecha === undefined || fecha === "" || isNaN(fecha))
    f = new Date();
  else f = fecha;
  const a = f.getFullYear();
  const m = (f.getMonth() + 1).toString().padStart(2, "0");
  const d = f.getDate().toString().padStart(2, "0");
  return `${a}-${m}-${d}`;
};


var pacienteConverter = {

  toFirestore: function (paciente) {
    let fechaparams = paciente.fecNac.split("-");
    console.log('fechaNac', paciente.fecNac)
    let fecNac = new Date(fechaparams[0], fechaparams[1] - 1, fechaparams[2]);
    console.log('fechaNacDate', fecNac)

    return {
      sexo: paciente.sexo,
      id: paciente.id,
      tipDoc: paciente.tipDoc ? paciente.tipDoc : "DNI",
      numDoc: paciente.numDoc,
      apellidos: paciente.apellidos,
      nombres: paciente.nombres,
      fecNac: fecNac,
      telefono: paciente.telefono,
      direccion: paciente.direccion ? paciente.direccion : "",
      correo: paciente.correo,
      patologias: paciente.patologias,
      estado: paciente.estado ? paciente.estado : "S",
      empresaId: paciente.empresaId,
      created_at: paciente.created_at ? paciente.created_at : moment().tz("America/Lima").toDate(),
      updated_at: paciente.updated_at ? paciente.updated_at : moment().tz("America/Lima").toDate(),
      created_by: paciente.created_by ? paciente.created_by : "",
      updated_by: paciente.updated_by ? paciente.updated_by : "",
    };
  },
  fromFirestore: function (snapshot, options) {
    const data = snapshot.data(options);
    return {
      sexo: data().sexo,
      id: data().id,
      tipDoc: data().tipDoc,
      numDoc: data().numDoc,
      apellidos: data().apellidos,
      nombres: data().nombres,
      fecNac: data().fecNac ? fechaACadena(data.fecNac().toDate()) : fechaACadena(new Date()),
      telefono: data().telefono,
      direccion: data().direccion,
      correo: data().correo,
      patologias: data().patologias,
      estado: data().estado,
      empresaId: data().empresaId,

    };
  },
};

export const updatePaciente = (myPaciente) => {

  return function (dispatch) {
    let paciente = { ...myPaciente };

    let pacienteRef;
    const currentTime = moment().tz("America/Lima").format();

    console.log('actualizando paciente', paciente);
    paciente.updated_at = currentTime;
    console.log('actualizando paciente', paciente);
    paciente.updated_at = currentTime;
    // Updated to use subcollection logic is handled in service, but we might not need to change this if service handles it. 
    // Wait, updatePaciente service wasn't refactored to take ID, it takes object.
    // But `pacienteRef = db.collection("pacientes").doc(paciente.id);` was in action!
    // I need to change this line in the action to use subcollection path.
    pacienteRef = db.collection("empresas").doc(paciente.empresaId).collection("pacientes").doc(paciente.id);


    dispatch(httpRequest());
    pacienteRef
      .withConverter(pacienteConverter)
      .set(paciente)
      .then(() => {
        paciente.id = pacienteRef.id;
        dispatch(httpSuccess());
        dispatch(setPaciente(paciente));
      })
      .catch((err) => {
        dispatch(httpFailure(err));
      });
  };
};

export const addPaciente = (myPaciente) => {
  let paciente = { ...myPaciente };
  return function (dispatch) {
    var pacienteRef = db.collection("empresas").doc(paciente.empresaId).collection("pacientes").doc();
    dispatch(httpRequest());
    paciente.id = pacienteRef.id;
    pacienteRef
      .withConverter(pacienteConverter)
      .set(paciente)
      .then(() => {
        dispatch(crearCuenta(paciente));
        dispatch(setPaciente(paciente));
        dispatch(addPacienteInArray(paciente));
        dispatch(httpSuccess());
      })
      .catch((err) => {
        dispatch(httpFailure(err));
      });
  };
};
export const loadPatientData = (paciente, fecha, atencionId) => {
  return async (dispatch) => {
    dispatch(httpRequest());
    try {
      dispatch(setPaciente(paciente));
      dispatch(setPacienteSesion(true));

      await Promise.all([
        dispatch(getCuenta(paciente.id, paciente.empresaId)),
        dispatch(fetchPrestations(paciente.id, paciente.empresaId)),
        dispatch(getOdontograma(paciente.id, paciente.empresaId)),
        dispatch(fetchDiagnosticos(paciente.id, paciente.empresaId))
      ]);

      dispatch(httpSuccess());
    } catch (error) {
      console.error("Error loading patient data:", error);
      dispatch(httpFailure(error));
    }
  };
};
